import { faAdd, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  DrawingManager,
  Polygon,
  Marker,
} from "@react-google-maps/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import _ from "lodash";
import Select from "react-select";
import LoadingIcon from "../../../components/loading/LoadingIcon";
import { setIsUpdating } from "../../../redux/app/regions/region-slice";
import AutoCompletePlaceItem from "../../../components/b2c/AutoCompletePlaceItem";
// import ScriptLoaded from "./ScriptLoaded";
let rates = {};
let houryRates = {};
// let path = [];
let pathsWithDetail = [];
let vehicleCategory = {};

let path = [];
// let pathsWithDetail = [];

const FlatRegionEdit = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { allVehicles, categories } = useSelector((state) => state.vehicle);
  const { regionData, isUpdating, flatRegionData, flatRegionMetaData } =
    useSelector((state) => state.region);
  const navigate = useNavigate();
  const { id } = useParams();
  const [center, setcenter] = useState();
  const [pathInitial, setPathInitial] = useState([]);
  const [regionMetaDataEdit, setregionMetaDataEdit] = useState({});
  const { placesbygoogle } = useSelector((state) => state.map);

  const [regionEdit, setregionEdit] = useState({
    name: "",
    distance_per_hour: "",
  });

  const [sourceRegionInput, setsourceRegionInput] = useState("");
  const [ratesByMilage, setratesByMilage] = useState([]);
  const [
    rates_by_milage_without_meetngret,
    setRates_by_milage_without_meetngret,
  ] = useState([]);
  const [ratesByHour, setratesByHour] = useState([]);
  const [category, setCategory] = useState({});
  const [foundedLatLng, setfoundedLatLng] = useState();
  const [pathCheck, setpathCheck] = useState([]);
  const [render, setrender] = useState(true);
  const [sourceSuggestionOpen, setSourceSuggestionOpen] = useState(false);

  console.log(
    rates_by_milage_without_meetngret,
    "rates_by_milage_without_meetngret"
  );

  useEffect(() => {
    if (flatRegionData) {
      console.log(
        flatRegionData?.rates_by_milage_without_meetngret?.length,
        "flatRegionData?.rates_by_milage_without_meetngret<---"
      );
      if (flatRegionData?.rates_by_milage_without_meetngret?.length > 0) {
        setRates_by_milage_without_meetngret(
          flatRegionData?.rates_by_milage_without_meetngret
        );
      }
      if (flatRegionData?.rates_by_milage_without_meetngret?.length === 0) {
        setRates_by_milage_without_meetngret(flatRegionData?.rate_by_milage);
      }
    }
  }, [flatRegionData]);

  useEffect(() => {
    flatRegionData && setratesByMilage(flatRegionData?.rate_by_milage);
  }, [flatRegionData]);

  useEffect(() => {
    // regionData &&
    //   regionData?.rate_by_hour?.forEach((rate) => {
    //     setratesByHour((prev) => [...prev, rate]);
    //   });

    flatRegionData && setratesByHour(flatRegionData?.rate_by_hour);
  }, [flatRegionData]);

  useEffect(() => {
    const getPlacesFromGoogleData = setTimeout(() => {
      if (sourceRegionInput?.length > 2 && sourceSuggestionOpen) {
        dispatch({
          type: "GET_PLACES_FROM_GOOGLE",
          payload: sourceRegionInput,
        });
      }
    }, 200);
    return () => clearTimeout(getPlacesFromGoogleData);
  }, [sourceRegionInput, sourceSuggestionOpen]);

  useEffect(() => {
    if (id) {
      console.log(id, "id oooooo");
      dispatch({
        type: "GET_FLAT_REGION_META_DATA",
        payload: {
          token,
          regionId: id,
        },
      });
    }
  }, [id]);

  useEffect(() => {
    flatRegionMetaData &&
      setregionMetaDataEdit({
        country: flatRegionMetaData?.country,
        city: flatRegionMetaData?.city,
        continent: flatRegionMetaData?.continent,
        shenghen: flatRegionMetaData?.shenghen,
        isMultiply: flatRegionMetaData?.isMultiply,
        mutiplyQty: flatRegionMetaData?.mutiplyQty,
      });
  }, [flatRegionMetaData]);

  useEffect(() => {
    flatRegionData &&
      setregionEdit({
        name: flatRegionData?.name,
        distance_per_hour: flatRegionData?.distance_per_hour,
        cityCenterLatLng: flatRegionData?.cityCenterLatLng,
        cityCenterName: flatRegionData?.cityCenterName,
        nightPrice: flatRegionData?.nightPrice,
        nightStartTime: flatRegionData?.nightStartTime,
        nightEndTime: flatRegionData?.nightEndTime,
        isMultiply: flatRegionData?.isMultiply,
        mutiplyQty: flatRegionData?.mutiplyQty,
      });
  }, [flatRegionData]);

  useEffect(() => {
    dispatch({
      type: "SHOW_VEHICLE_CATEGORY",
      payload: {
        token: token,
      },
    });
  }, []);

  useEffect(() => {
    // window.location.reload();
    setPathInitial([]);
    dispatch({
      type: "GET_FLAT_REGION_BY_ID",
      payload: {
        token,
        regionId: id,
      },
    });
  }, [dispatch, token, id, setPathInitial]);

  useEffect(() => {
    flatRegionData &&
      flatRegionData?.LocationPoints?.forEach((element) => {
        pathInitial.push({
          // key:
          //   element?.geometry?.location?.lat +
          //   "," +
          //   element?.geometry?.location?.lng,
          lat: element?.geometry?.location?.lat,
          lng: element?.geometry?.location?.lng,
        });
        pathCheck.push({
          lat: element?.geometry?.location?.lat,
          lng: element?.geometry?.location?.lng,
        });
        setpathCheck(pathCheck);

        setPathInitial(pathInitial);
      });
    let x = 0;
    let y = 0;
    let z = 0;

    pathInitial.forEach((element) => {
      var latitude = (element.lat * Math.PI) / 180;
      var longitude = (element.lng * Math.PI) / 180;

      x += Math.cos(latitude) * Math.cos(longitude);
      y += Math.cos(latitude) * Math.sin(longitude);
      z += Math.sin(latitude);
    });

    var total = pathInitial.length;

    x = x / total;
    y = y / total;
    z = z / total;

    var centralLongitude = Math.atan2(y, x);
    var centralSquareRoot = Math.sqrt(x * x + y * y);
    var centralLatitude = Math.atan2(z, centralSquareRoot);

    let center = {
      lat: (centralLatitude * 180) / Math.PI,
      lng: (centralLongitude * 180) / Math.PI,
    };
    setcenter(center);
  }, [flatRegionData]);

  const containerStyle = {
    width: "700px",
    height: "600px",
    margin: "10px 10px",
  };

  let initialState = {
    lat: 38.685,
    lng: -115.234,
  };

  let x = 0;
  let y = 0;
  let z = 0;

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  // const onLoad = (drawingManager) => {
  //
  // };

  //

  const [region, setregion] = useState({
    name: "",
    distance_unit: "",
    distance_per_hour: 0,
    locationPoints: [],
  });

  const getLatLongSourceAction = async (placeid, source) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/placesDetailsSource?place_id=${placeid}`
    );

    setregionEdit({
      ...regionEdit,
      cityCenterLatLng: {
        lat: response?.data?.result?.lat,
        lng: response?.data?.result?.lng,
      },
      cityCenterName: source + response?.data?.address,
    });
  };

  const [editRegionPoints, seteditRegionPoints] = useState(false);

  const mapUpdateHandler = async () => {
    dispatch(
      setIsUpdating({
        isUpdating: true,
      })
    );
    if (editRegionPoints) {
      for (let i in pathInitial) {
        let latlan = pathInitial[i]?.lat + "," + pathInitial[i]?.lng;
        var locationInfoDetail = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlan}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
        );

        pathsWithDetail.push(locationInfoDetail?.data?.results[0]);
      }
    }

    let regionPayload;

    if (editRegionPoints) {
      regionPayload = {
        name: regionEdit?.name,

        distance_per_hour: regionEdit?.distance_per_hour,
        LocationPoints: pathsWithDetail,
        cityCenterLatLng: regionEdit?.cityCenterLatLng,
        cityCenterName: regionEdit?.cityCenterName,
        nightPrice: regionEdit?.nightPrice,
        nightEndTime: regionEdit?.nightEndTime,
        nightStartTime: regionEdit?.nightStartTime,
        mutiplyQty: regionEdit?.mutiplyQty,
        isMultiply: regionEdit?.isMultiply,
        rate_by_milage: ratesByMilage.map((rate) => {
          return {
            category: rate?.category,
            rate: rate?.rate,
            min_fare: rate?.min_fare,
            start_fee: rate?.start_fee,
            vehicleName: rate?.vehicleName,
            price_per_min: rate?.price_per_min,
          };
        }),
        rates_by_milage_without_meetngret:
          rates_by_milage_without_meetngret.map((rate) => {
            return {
              category: rate?.category,
              rate: rate?.rate,
              min_fare: rate?.min_fare,
              start_fee: rate?.start_fee,
              vehicleName: rate?.vehicleName,
              price_per_min: rate?.price_per_min,
            };
          }),
        rate_by_hour: ratesByHour.map((rate) => {
          return {
            category: rate?.category,
            rate: rate?.rate,
            min_fare: rate?.min_fare,
            start_fee: rate?.start_fee,
            vehicleName: rate?.vehicleName,
            price_per_min: rate?.price_per_min,
          };
        }),
      };
    } else {
      regionPayload = {
        name: regionEdit?.name,
        mutiplyQty: regionEdit?.mutiplyQty,
        isMultiply: regionEdit?.isMultiply,
        distance_per_hour: regionEdit?.distance_per_hour,
        cityCenterLatLng: regionEdit?.cityCenterLatLng,
        cityCenterName: regionEdit?.cityCenterName,
        nightPrice: regionEdit?.nightPrice,
        nightEndTime: regionEdit?.nightEndTime,
        nightStartTime: regionEdit?.nightStartTime,
        // LocationPoints: pathsWithDetail,
        rate_by_milage: ratesByMilage.map((rate) => {
          return {
            category: rate?.category,
            rate: rate?.rate,
            min_fare: rate?.min_fare,
            start_fee: rate?.start_fee,
            vehicleName: rate?.vehicleName,
            price_per_min: rate?.price_per_min,
          };
        }),
        rates_by_milage_without_meetngret:
          rates_by_milage_without_meetngret.map((rate) => {
            return {
              category: rate?.category,
              rate: rate?.rate,
              min_fare: rate?.min_fare,
              start_fee: rate?.start_fee,
              vehicleName: rate?.vehicleName,
              price_per_min: rate?.price_per_min,
            };
          }),
        rate_by_hour: ratesByHour.map((rate) => {
          return {
            category: rate?.category,
            rate: rate?.rate,
            min_fare: rate?.min_fare,
            start_fee: rate?.start_fee,
            vehicleName: rate?.vehicleName,
            price_per_min: rate?.price_per_min,
          };
        }),
      };
    }

    dispatch({
      type: "UPDATE_FLAT_REGION",
      payload: {
        regionId: id,
        body: regionPayload,
        token,
      },
    });

    dispatch({
      type: "UPDATE_FLAT_REGION_META_DATA",
      payload: {
        regionId: id,
        body: regionMetaDataEdit,
        token,
      },
    });

    dispatch(
      setIsUpdating({
        isUpdating: false,
      })
    );

    // path = [];
    setPathInitial([]);
    pathsWithDetail = [];
    rates = {};
    houryRates = {};
  };
  return (
    <div>
      <div className="flex justify-between px-5 py-2 shadow-md items-center">
        <div className=" text-xl text-primary font-semibold">Edit Region</div>
        {isUpdating && (
          <div className="flex space-x-9 items-center">
            <LoadingIcon />
            <div className="italic text-teal-800">Updating...</div>
          </div>
        )}
        <div className="flex space-x-5">
          <div
            onClick={mapUpdateHandler}
            className="bg-secondary hover:bg-gray-300 hover:text-black text-white px-3 py-1 rounded-md cursor-pointer"
          >
            Save
          </div>
          <Link
            onClick={() => {
              window.relode();
            }}
            to="/flatregions"
          >
            <FontAwesomeIcon
              icon={faXmark}
              className="w-5 h-5 mt-1.5 text-primary cursor-pointer"
            />
          </Link>
        </div>
      </div>
      <div className="">
        {editRegionPoints ? (
          <div
            onClick={() => {
              seteditRegionPoints(false);
            }}
            className="bg-secondary w-max px-2 py-1 items-center flex text-sm  h-5 rounded-md text-white cursor-pointer"
          >
            Close
          </div>
        ) : (
          <div
            onClick={() => {
              seteditRegionPoints(true);
            }}
            className="bg-secondary w-max px-2 py-1 items-center flex text-sm  h-5 rounded-md text-white cursor-pointer"
          >
            Edit RegionPoints
          </div>
        )}
        <div className="flex space-x-1">
          {pathInitial.length && (
            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
              <GoogleMap
                id="marker-example"
                mapContainerStyle={containerStyle}
                // mapContainerStyle={containerStyle}
                center={center}
                zoom={8}
              >
                {regionEdit?.cityCenterLatLng && (
                  <>
                    <Marker
                      position={regionEdit?.cityCenterLatLng}
                      // onClick={() => {
                      //   setfoundedLatLng(regionEdit?.cityCenterLatLng);
                      // }}
                    />
                  </>
                )}
                {/* Child components, such as markers, info windows, etc. */}
                <Polygon
                  editable={true}
                  draggable={true}
                  paths={pathInitial ? pathInitial : null}
                  onDragEnd={(e) => {
                    // setpathInitial(e.latLng);
                  }}
                  onDrag={(e) => {
                    // setpathInitial(e.latLng);
                  }}
                  onMouseDown={(e) => {
                    pathInitial.find((latlng) => {
                      latlng.lat === e.latLng.lat() &&
                        latlng.lng === e.latLng.lng() &&
                        setfoundedLatLng(latlng);

                      // setpathInitial(e.latLng);
                    });
                  }}
                  onMouseUp={(e) => {
                    if (!foundedLatLng) {
                      pathCheck.push({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      });
                      setpathCheck(pathCheck);
                    }

                    pathInitial.forEach((latlng) => {
                      if (
                        latlng.lat === foundedLatLng.lat &&
                        latlng.lng === foundedLatLng.lng
                      ) {
                        latlng.lat = e.latLng.lat();
                        latlng.lng = e.latLng.lng();
                      }
                    });
                    setPathInitial(pathInitial);

                    // setpathInitial(e.latLng);
                  }}
                  options={{
                    drawingControl: true,
                    fillColor: "#39121739",
                    fillOpacity: 1,

                    strokeColor: "red",
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    clickable: false,
                    draggable: editRegionPoints,
                    editable: editRegionPoints,
                  }}
                />
              </GoogleMap>
            </LoadScript>
          )}
          <div className="my-3 shadow-md w-full space-y-5">
            <div className="grid grid-cols-2">
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Enter Region Name
                </div>
                <input
                  type="text"
                  placeholder="Enter Region Name"
                  className="focus:outline-none border-b-2 border-gray-300  py-1 w-full textField"
                  onChange={(e) => {
                    // setregion({ ...region, name: e.target.value });
                    setregionEdit({ ...regionEdit, name: e.target.value });
                  }}
                  value={regionEdit?.name}
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Distance Unit
                </div>
                <input
                  type="text"
                  placeholder="Enter Region Name"
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1 textField"
                  value={flatRegionData?.distance_unit}
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Distance per hour
                </div>
                <input
                  type="text"
                  placeholder="Enter distance per hour"
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1 textField"
                  onChange={(e) => {
                    setregionEdit({
                      ...regionEdit,
                      distance_per_hour: e.target.value,
                    });
                  }}
                  value={regionEdit?.distance_per_hour}
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Country
                </div>
                <input
                  type="text"
                  placeholder="Enter country "
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1 textField"
                  onChange={(e) => {
                    setregionMetaDataEdit({
                      ...regionMetaDataEdit,
                      country: e.target.value,
                    });
                  }}
                  value={regionMetaDataEdit?.country}
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">City</div>
                <input
                  type="text"
                  placeholder="Enter city"
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1 textField"
                  onChange={(e) => {
                    // setregionEdit({
                    //   ...regionEdit,
                    //   distance_per_hour: e.target.value,
                    // });
                    setregionMetaDataEdit({
                      ...regionMetaDataEdit,
                      city: e.target.value,
                    });
                  }}
                  value={regionMetaDataEdit?.city}
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Continent
                </div>
                <input
                  type="text"
                  placeholder="Enter continent"
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1 textField"
                  onChange={(e) => {
                    setregionMetaDataEdit({
                      ...regionMetaDataEdit,
                      continent: e.target.value,
                    });
                  }}
                  value={regionMetaDataEdit?.continent}
                />
              </div>
              <div className="mx-2 my-2 flex items-center">
                <div className="text-sm text-gray-600 font-semibold">
                  Shengen
                </div>
                <input
                  type="checkbox"
                  placeholder="Enter distance per hour"
                  className="focus:outline-none border-b-2 border-gray-300 w-10 textField"
                  onChange={(e) => {
                    setregionMetaDataEdit({
                      ...regionMetaDataEdit,
                      shenghen: e.target.checked,
                    });
                  }}
                  checked={regionMetaDataEdit?.shenghen}
                />
              </div>
              <div className="mx-2 my-2 flex items-center">
                <div className="mx-2 my-2 flex items-center">
                  <div className="text-sm text-gray-600 font-semibold">
                    multiply
                  </div>
                  <input
                    type="checkbox"
                    placeholder="Enter distance per hour"
                    className="focus:outline-none border-b-2 border-gray-300 w-10 textField"
                    onChange={(e) => {
                      setregionEdit({
                        ...regionEdit,
                        isMultiply: e.target.checked,
                      });
                    }}
                    checked={regionEdit?.isMultiply}
                  />
                </div>
                <div className="mx-2 my-2 flex items-center space-x-2">
                  <div className="text-sm text-gray-600 font-semibold">
                    multiply qty
                  </div>
                  <input
                    type="number"
                    placeholder=""
                    className="focus:outline-none border-b-2 border-gray-300 w-10 textField"
                    onChange={(e) => {
                      setregionEdit({
                        ...regionEdit,
                        mutiplyQty: e.target.value,
                      });
                    }}
                    value={regionEdit?.mutiplyQty}
                  />
                </div>
              </div>
              <div className="mx-2 my-2 ">
                <div className="text-sm text-gray-600 font-semibold">
                  City Center
                </div>
                <input
                  type="text"
                  placeholder="City Center"
                  className="focus:outline-none border-b-2 border-gray-300 w-full textField"
                  onChange={(e) => {
                    // setregionEdit({ ...regionEdit, name: e.target.value });
                    setsourceRegionInput(e.target.value);
                    setSourceSuggestionOpen(true);
                    setregionEdit({
                      ...regionEdit,
                      cityCenterName: e.target.value,
                    });
                  }}
                  value={regionEdit?.cityCenterName}
                />
                {placesbygoogle.length > 0 && sourceSuggestionOpen && (
                  <>
                    <div className="bg-[#eae9e9] absolute w-[90%] sm:w-[85%] md:w-[82%] lg:w-[88%] xl:w-[91%] 2xl:w-[93%] mx-20 h-72 -translate-x-20 -translate-y-3.5 scrollbar rounded-bl-md rounded-br-md shadow-2xl z-10">
                      <div className="overflow-y-auto">
                        {placesbygoogle?.map((place) => (
                          <>
                            <AutoCompletePlaceItem
                              onClick={() => {
                                // setting source input to input field and to redux store
                                // dispatch(
                                //   setSourceInput({
                                //     sourceInputFromApi: place,
                                //   })
                                // );
                                let selectedPlace =
                                  place?.terms[0]?.value +
                                  " " +
                                  place?.terms[1]?.value +
                                  " " +
                                  place?.terms[2]?.value;

                                // and the same time finding lat an  lng to store to db and to get distance
                                // dispatch({
                                //   type: "GET_LAT_LAN_OF_SOURCE",
                                //   payload: place.place_id,
                                // });

                                getLatLongSourceAction(
                                  place.place_id,
                                  selectedPlace
                                );
                                setSourceSuggestionOpen(false);
                              }}
                              key={place?.place_id}
                              placeTerms={place?.terms}
                            />
                          </>
                        ))}
                      </div>
                      <div className=" static flex items-center justify-end mx-3 space-x-1 text-left ">
                        <div className="text-sm font-semibold text-gray-400">
                          Powered By{" "}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="px-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Night Price
                </div>
                <input
                  type="Number"
                  placeholder="Night Price"
                  className="focus:outline-none border-b-2 border-gray-300 w-full textField"
                  onChange={(e) => {
                    setregionEdit({
                      ...regionEdit,
                      nightPrice: parseFloat(e.target.value),
                    });
                  }}
                  value={regionEdit?.nightPrice}
                />
              </div>
              <div className=" flex space-x-3 ">
                <div>
                  <div className="text-sm text-gray-600 font-semibold">
                    Night Start Time
                  </div>
                  <input
                    type="time"
                    placeholder="Start time"
                    className="focus:outline-none border-b-2 border-gray-300 w-full textField"
                    onChange={(e) => {
                      setregionEdit({
                        ...regionEdit,
                        nightStartTime: e.target.value,
                      });
                    }}
                    value={regionEdit?.nightStartTime}
                  />
                </div>
                <div>
                  <div className="text-sm text-gray-600 font-semibold">
                    Night End Time
                  </div>
                  <input
                    type="time"
                    placeholder="End time"
                    className="focus:outline-none border-b-2 border-gray-300 w-full textField"
                    onChange={(e) => {
                      setregionEdit({
                        ...regionEdit,
                        nightEndTime: e.target.value,
                      });
                    }}
                    value={regionEdit?.nightEndTime}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="space-y-5">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    className="bg-primary text-white"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{
                      backgroundColor: "#fb4156 ",
                      fontSize: "15px",
                      borderRadius: "5px",
                      color: "white",
                    }}
                  >
                    <div>Rates By Milage</div>
                  </AccordionSummary>
                  <AccordionDetails className="flex flex-col">
                    <div className="flex justify-between">
                      <div></div>

                      <div
                        onClick={() => {
                          // setratesOfVehicle({
                          //   ...ratesOfVehicle,
                          //   "": {},
                          // });
                          setratesByMilage([
                            ...ratesByMilage,
                            {
                              v_id: Math.random().toString(36).substr(2, 9),
                            },
                          ]);
                        }}
                        className="flex border-teal-600 border px-2 py-1 rounded-sm text-teal-600 font-semibold hover:shadow-md  items-center w-min  space-x-1 cursor-pointer"
                      >
                        <div className="text-sm">Add</div>
                        <FontAwesomeIcon icon={faAdd} className=" " />
                      </div>
                    </div>
                    {/* {allVehicles.map((vehicle) => ( */}

                    {ratesByMilage?.map((rate, key) => {
                      return (
                        <>
                          <div
                            key={rate?.v_id}
                            className="flex items-center space-x-9 mb-3 border-b  border-gray-500 "
                          >
                            <div>
                              <div className="text-sm text-gray-600">
                                Choose Category
                              </div>
                              {rate?.v_id ? (
                                <Select
                                  className="w-56"
                                  value={{
                                    value: rate?.category,
                                    label: rate?.category?.name,
                                  }}
                                  onChange={(e) => {
                                    setratesByMilage((prev) => {
                                      let newRates = [...prev];
                                      newRates[key].category = e.value;
                                      return newRates;
                                    });
                                  }}
                                  options={categories.map((category) => {
                                    return {
                                      value: category,
                                      label: category?.name,
                                    };
                                  })}
                                />
                              ) : (
                                <div className="w-52">
                                  {rate?.category?.name}
                                </div>
                              )}
                            </div>
                            <div>
                              <div>Choose Vechicle</div>

                              <Select
                                className="w-60"
                                value={{
                                  value: rate?.vehicleName,
                                  label: rate?.vehicleName,
                                }}
                                onChange={(e) => {
                                  // i have to update vehicle name in ratesByMilage
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      vehicleName: e?.value?.vehicleName,
                                    };
                                    return newRates;
                                  });
                                }}
                                options={rate?.category?.vehicles.map(
                                  (vehicle) => {
                                    return {
                                      value: vehicle,
                                      label: vehicle?.vehicleName,
                                    };
                                  }
                                )}
                              />
                            </div>
                            <div>
                              <div>Start Fee</div>

                              <input
                                type="number"
                                className="textField w-20 mb-1"
                                value={
                                  ratesByMilage[key]?.start_fee
                                    ? ratesByMilage[key]?.start_fee
                                    : rate?.start_fee
                                }
                                onChange={(e) => {
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      start_fee: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div>
                              <div>Rate</div>
                              <input
                                value={rate?.rate}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      rate: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div>
                              <div>Min Fare</div>
                              <input
                                value={rate?.min_fare}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      min_fare: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div>
                              <div>PP Mint</div>
                              <input
                                value={rate?.price_per_min}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      price_per_min: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div className="flex items-center">
                              <FontAwesomeIcon
                                onClick={() => {
                                  setratesByMilage((prev) => {
                                    let tmp = [...prev];

                                    tmp.splice(key, 1);

                                    return tmp;
                                  });
                                }}
                                icon={faTrash}
                                className="text-red-500  cursor-pointer hover:text-red-700"
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
                {/* <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  className="bg-primary text-white"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  sx={{
                    backgroundColor: "#fb4156 ",
                    fontSize: "15px",
                    borderRadius: "5px",
                    color: "white",
                  }}
                >
                  <div>Rates By Hour</div>
                </AccordionSummary>
                <AccordionDetails className="flex flex-col">
                  <div className="flex justify-between">
                    <div></div>

                    <div
                      onClick={() => {
                        setratesByHour([
                          ...ratesByHour,
                          {
                            v_id: Math.random().toString(36).substr(2, 9),
                          },
                        ]);
                      }}
                      className="flex border-teal-600 border px-2 py-1 rounded-sm text-teal-600 font-semibold hover:shadow-md  items-center w-min  space-x-1 cursor-pointer"
                    >
                      <div className="text-sm">Add</div>
                      <FontAwesomeIcon icon={faAdd} className=" " />
                    </div>
                  </div>
                  {ratesByHour?.map((rate, key) => {
                    return (
                      <>
                        <div className="flex items-center space-x-9 mb-3  border-gray-500 ">
                          <div>
                            <div className="text-sm text-gray-600">
                              Choose Category
                            </div>
                            {rate?.v_id ? (
                              <Select
                                className="w-56"
                                value={{
                                  value: rate?.category,
                                  label: rate?.category?.name,
                                }}
                                onChange={(e) => {
                                  setratesByHour((prev) => {
                                    let newRates = [...prev];
                                    newRates[key].category = e.value;
                                    return newRates;
                                  });
                                }}
                                options={categories.map((category) => {
                                  return {
                                    value: category,
                                    label: category?.name,
                                  };
                                })}
                              />
                            ) : (
                              <div className="w-52">
                                {rate?.category?.name}
                              </div>
                            )}
                          </div>
                          <div>
                            <div>Choose Vechicle</div>

                            <Select
                              className="w-60"
                              value={{
                                value: rate?.vehicleName,
                                label: rate?.vehicleName,
                              }}
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    vehicleName: e.value?.vehicleName,
                                  };

                                  return newRates;
                                });
                              }}
                              options={rate?.category?.vehicles.map(
                                (vehicle) => {
                                  return {
                                    value: vehicle,
                                    label: vehicle?.vehicleName,
                                  };
                                }
                              )}
                            />
                          </div>
                          <div>
                            <div>Start Fee</div>
                            <input
                              type="number"
                              value={rate?.start_fee}
                              className="textField w-20"
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    start_fee: parseFloat(e.target.value),
                                  };
                                  return newRates;
                                });
                              }}
                            />
                          </div>
                          <div>
                            <div>Rate</div>
                            <input
                              value={rate?.rate}
                              type="number"
                              className="textField w-20"
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    rate: parseFloat(e.target.value),
                                  };
                                  return newRates;
                                });
                              }}
                            />
                          </div>
                          <div>
                            <div>Min Fare</div>
                            <input
                              value={rate?.min_fare}
                              type="number"
                              className="textField w-20"
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    min_fare: parseFloat(e.target.value),
                                  };
                                  return newRates;
                                });
                              }}
                            />
                          </div>
                          <div className="flex items-center">
                            <FontAwesomeIcon
                              onClick={() => {
                                // first get the index of the vehicle
                                // then remove it from the array

                                setratesByHour((prev) => {
                                  let tmp = [...prev];

                                  tmp.splice(key, 1);

                                  return tmp;
                                });
                              }}
                              icon={faTrash}
                              className="text-red-500  cursor-pointer hover:text-red-700"
                            />
                          </div>
                        </div>
                      </>
                    );
                  })}
                </AccordionDetails>
              </Accordion> */}
              </div>
            </div>

            <div>
              <div className="space-y-5">
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                >
                  <AccordionSummary
                    className="bg-primary text-white"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{
                      backgroundColor: "#fb4156 ",
                      fontSize: "15px",
                      borderRadius: "5px",
                      color: "white",
                    }}
                  >
                    <div>Rates By Milage Without Meet and Greet</div>
                  </AccordionSummary>
                  <AccordionDetails className="flex flex-col">
                    <div className="flex justify-between">
                      <div></div>

                      <div
                        onClick={() => {
                          // setratesOfVehicle({
                          //   ...ratesOfVehicle,
                          //   "": {},
                          // });
                          setRates_by_milage_without_meetngret([
                            ...rates_by_milage_without_meetngret,
                            {
                              v_id: Math.random().toString(36).substr(2, 9),
                            },
                          ]);
                        }}
                        className="flex border-teal-600 border px-2 py-1 rounded-sm text-teal-600 font-semibold hover:shadow-md  items-center w-min  space-x-1 cursor-pointer"
                      >
                        <div className="text-sm">Add</div>
                        <FontAwesomeIcon icon={faAdd} className=" " />
                      </div>
                    </div>
                    {/* {allVehicles.map((vehicle) => ( */}

                    {rates_by_milage_without_meetngret?.map((rate, key) => {
                      return (
                        <>
                          <div
                            key={rate?.v_id}
                            className="flex items-center space-x-9 mb-3 border-b  border-gray-500 "
                          >
                            <div>
                              <div className="text-sm text-gray-600">
                                Choose Category
                              </div>
                              {rate?.v_id ? (
                                <Select
                                  className="w-56"
                                  value={{
                                    value: rate?.category,
                                    label: rate?.category?.name,
                                  }}
                                  onChange={(e) => {
                                    setRates_by_milage_without_meetngret(
                                      (prev) => {
                                        let newRates = [...prev];
                                        newRates[key].category = e.value;
                                        return newRates;
                                      }
                                    );
                                  }}
                                  options={categories.map((category) => {
                                    return {
                                      value: category,
                                      label: category?.name,
                                    };
                                  })}
                                />
                              ) : (
                                <div className="w-52">
                                  {rate?.category?.name}
                                </div>
                              )}
                            </div>
                            <div>
                              <div>Choose Vechicle</div>

                              <Select
                                className="w-60"
                                value={{
                                  value: rate?.vehicleName,
                                  label: rate?.vehicleName,
                                }}
                                onChange={(e) => {
                                  // i have to update vehicle name in ratesByMilage
                                  setRates_by_milage_without_meetngret(
                                    (prev) => {
                                      let newRates = [...prev];
                                      newRates[key] = {
                                        ...newRates[key],
                                        vehicleName: e?.value?.vehicleName,
                                      };
                                      return newRates;
                                    }
                                  );
                                }}
                                options={rate?.category?.vehicles.map(
                                  (vehicle) => {
                                    return {
                                      value: vehicle,
                                      label: vehicle?.vehicleName,
                                    };
                                  }
                                )}
                              />
                            </div>
                            <div>
                              <div>Start Fee</div>

                              <input
                                type="number"
                                className="textField w-20 mb-1"
                                value={
                                  rates_by_milage_without_meetngret[key]
                                    ?.start_fee
                                    ? rates_by_milage_without_meetngret[key]
                                        ?.start_fee
                                    : rate?.start_fee
                                }
                                onChange={(e) => {
                                  setRates_by_milage_without_meetngret(
                                    (prev) => {
                                      let newRates = [...prev];
                                      newRates[key] = {
                                        ...newRates[key],
                                        start_fee: parseFloat(e.target.value),
                                      };
                                      return newRates;
                                    }
                                  );
                                }}
                              />
                            </div>
                            <div>
                              <div>Rate</div>
                              <input
                                value={rate?.rate}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setRates_by_milage_without_meetngret(
                                    (prev) => {
                                      let newRates = [...prev];
                                      newRates[key] = {
                                        ...newRates[key],
                                        rate: parseFloat(e.target.value),
                                      };
                                      return newRates;
                                    }
                                  );
                                }}
                              />
                            </div>
                            <div>
                              <div>Min Fare</div>
                              <input
                                value={rate?.min_fare}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setRates_by_milage_without_meetngret(
                                    (prev) => {
                                      let newRates = [...prev];
                                      newRates[key] = {
                                        ...newRates[key],
                                        min_fare: parseFloat(e.target.value),
                                      };
                                      return newRates;
                                    }
                                  );
                                }}
                              />
                            </div>
                            <div>
                              <div>PP Mint</div>
                              <input
                                value={rate?.price_per_min}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setRates_by_milage_without_meetngret(
                                    (prev) => {
                                      let newRates = [...prev];
                                      newRates[key] = {
                                        ...newRates[key],
                                        price_per_min: parseFloat(
                                          e.target.value
                                        ),
                                      };
                                      return newRates;
                                    }
                                  );
                                }}
                              />
                            </div>
                            <div className="flex items-center">
                              <FontAwesomeIcon
                                onClick={() => {
                                  setRates_by_milage_without_meetngret(
                                    (prev) => {
                                      let tmp = [...prev];

                                      tmp.splice(key, 1);

                                      return tmp;
                                    }
                                  );
                                }}
                                icon={faTrash}
                                className="text-red-500  cursor-pointer hover:text-red-700"
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
                {/* <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  className="bg-primary text-white"
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  sx={{
                    backgroundColor: "#fb4156 ",
                    fontSize: "15px",
                    borderRadius: "5px",
                    color: "white",
                  }}
                >
                  <div>Rates By Hour</div>
                </AccordionSummary>
                <AccordionDetails className="flex flex-col">
                  <div className="flex justify-between">
                    <div></div>

                    <div
                      onClick={() => {
                        setratesByHour([
                          ...ratesByHour,
                          {
                            v_id: Math.random().toString(36).substr(2, 9),
                          },
                        ]);
                      }}
                      className="flex border-teal-600 border px-2 py-1 rounded-sm text-teal-600 font-semibold hover:shadow-md  items-center w-min  space-x-1 cursor-pointer"
                    >
                      <div className="text-sm">Add</div>
                      <FontAwesomeIcon icon={faAdd} className=" " />
                    </div>
                  </div>
                  {ratesByHour?.map((rate, key) => {
                    return (
                      <>
                        <div className="flex items-center space-x-9 mb-3  border-gray-500 ">
                          <div>
                            <div className="text-sm text-gray-600">
                              Choose Category
                            </div>
                            {rate?.v_id ? (
                              <Select
                                className="w-56"
                                value={{
                                  value: rate?.category,
                                  label: rate?.category?.name,
                                }}
                                onChange={(e) => {
                                  setratesByHour((prev) => {
                                    let newRates = [...prev];
                                    newRates[key].category = e.value;
                                    return newRates;
                                  });
                                }}
                                options={categories.map((category) => {
                                  return {
                                    value: category,
                                    label: category?.name,
                                  };
                                })}
                              />
                            ) : (
                              <div className="w-52">
                                {rate?.category?.name}
                              </div>
                            )}
                          </div>
                          <div>
                            <div>Choose Vechicle</div>

                            <Select
                              className="w-60"
                              value={{
                                value: rate?.vehicleName,
                                label: rate?.vehicleName,
                              }}
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    vehicleName: e.value?.vehicleName,
                                  };

                                  return newRates;
                                });
                              }}
                              options={rate?.category?.vehicles.map(
                                (vehicle) => {
                                  return {
                                    value: vehicle,
                                    label: vehicle?.vehicleName,
                                  };
                                }
                              )}
                            />
                          </div>
                          <div>
                            <div>Start Fee</div>
                            <input
                              type="number"
                              value={rate?.start_fee}
                              className="textField w-20"
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    start_fee: parseFloat(e.target.value),
                                  };
                                  return newRates;
                                });
                              }}
                            />
                          </div>
                          <div>
                            <div>Rate</div>
                            <input
                              value={rate?.rate}
                              type="number"
                              className="textField w-20"
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    rate: parseFloat(e.target.value),
                                  };
                                  return newRates;
                                });
                              }}
                            />
                          </div>
                          <div>
                            <div>Min Fare</div>
                            <input
                              value={rate?.min_fare}
                              type="number"
                              className="textField w-20"
                              onChange={(e) => {
                                setratesByHour((prev) => {
                                  let newRates = [...prev];
                                  newRates[key] = {
                                    ...newRates[key],
                                    min_fare: parseFloat(e.target.value),
                                  };
                                  return newRates;
                                });
                              }}
                            />
                          </div>
                          <div className="flex items-center">
                            <FontAwesomeIcon
                              onClick={() => {
                                // first get the index of the vehicle
                                // then remove it from the array

                                setratesByHour((prev) => {
                                  let tmp = [...prev];

                                  tmp.splice(key, 1);

                                  return tmp;
                                });
                              }}
                              icon={faTrash}
                              className="text-red-500  cursor-pointer hover:text-red-700"
                            />
                          </div>
                        </div>
                      </>
                    );
                  })}
                </AccordionDetails>
              </Accordion> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlatRegionEdit;
